import {
  HttpClient, HttpParams, HttpHeaders
} from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { AppImagenes } from '../models/appImagenes.model';
import { AppConfig } from '../configuration/app.config';


@Injectable({ providedIn: 'root' })
export class AppImagenesService extends HttpClientBaseService implements IServiceBase<AppImagenes> {
  constructor(_http: HttpClient) {
    super(_http, 'AppImagenenes/', '', false);
  }
  getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<AppImagenes>> {
    throw new Error('Method not implemented.');
  }

  // Obtiene las facturas del usario según su rol (Cliente o proveedor.)
  public getAllModels(): Observable<AppImagenes[]> {
    return super.getAll<AppImagenes[]>();
  }



  public getModel(id: any): Observable<AppImagenes> {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}images/${id}`;

    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    return this.http.get<AppImagenes>(url, { headers: headers });
  }


  public updateModel(id: string, data: Partial<AppImagenes>): Observable<AppImagenes> {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}images/${id}`;
    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    const payload = {
      ...data,
      imageData: data.base64,
      modifiedBy: AppConfig.settings.apiServerPE.system
    };


    // Realizar la petición PATCH y devolver el resultado como un Observable
    return this.http.patch<AppImagenes>(url, payload, { headers: headers });
  }


}